import { Component } from 'react';
import { BiSolidError } from 'react-icons/bi';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error('Caught from Error Boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center w-screen h-screen">
          <div className="px-4 errorMsgWrapper">
            <BiSolidError
              className="h-auto mb-4 ml-auto mr-auto text-red-600 errorIcon d-block"
              style={{ width: '50px' }}
            />
            <h1>
              Something went wrong, Please refresh your page or try again
              after some time.{' '}
            </h1>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
